'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _EnterOutlined = _interopRequireDefault(require('./lib/icons/EnterOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _EnterOutlined;
exports.default = _default;
module.exports = _default;